import { useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getAvailableSingleOpportunities } from '@swf/core/models/sports/utils/betSlip/getAvailableOpportunities';
import { getIsSingleOpportunity } from '@swf/core/models/sports/utils/betSlip/getIsOpportunity';
import { select } from '@swf/core/store';
import type { MultipleOpportunity, SingleOpportunity } from '@swf/generated/types/api/sports';

import type { FormData } from '../types';

const useIsMultipleStartingPriceOpportunity = (
  opportunity: SingleOpportunity | MultipleOpportunity
) => {
  const { values } = useFormState<FormData>();
  const singleOpportunities = useSelector(select.betSlip.singleOpportunities);
  const availableSingles = getAvailableSingleOpportunities(singleOpportunities);
  const isSingleOpportunity = getIsSingleOpportunity(opportunity);

  if (isSingleOpportunity) return false;

  const { runnersIds } = opportunity;

  return runnersIds.some((runnerId) =>
    availableSingles.some((single) => {
      const { selectionId, marketId } = single.runnerId;
      const isSingleOpportunityPartOfMultiple =
        selectionId === runnerId.selectionId && marketId === runnerId.marketId;

      return (
        isSingleOpportunityPartOfMultiple &&
        (!single.winRunnerOdds || values[single.id]?.startingPriceSelected)
      );
    })
  );
};

export default useIsMultipleStartingPriceOpportunity;
